exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mb-2[data-v-7aef4eab] {\n  margin-bottom: 16px;\n}\n.mb-3[data-v-7aef4eab] {\n  margin-bottom: 24px;\n}\n.mt-3[data-v-7aef4eab] {\n  margin-top: 24px;\n}\n", ""]);

// exports
